import React from 'react';

interface Props {
  width?: string;
  height?: string;
  className?: string;
}

const BoxOutline: React.FC<Props> = ({ width, height, className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      className={className}
    >
      <g fillRule="evenodd">
        <g fillRule="nonzero">
          <path
            d="M3.72 7c-.374 0-.682.297-.72.667v5.928c.038 1.889 1.578 3.403 3.488 3.403 1.349 0 2.51-.747 3.072-1.858.599 1.074 1.76 1.858 3.072 1.858 1.91 0 3.488-1.56 3.488-3.448.036-1.925-1.543-3.48-3.455-3.48-1.347 0-2.51.746-3.071 1.857-.6-1.074-1.761-1.858-3.072-1.858-.786 0-1.494.267-2.093.712V7.667c0-.37-.297-.667-.709-.667zm16.484 3.047c-.177.018-.337.096-.45.245l-1.541 2.035-1.576-1.99c-.225-.297-.668-.37-.967-.112-.3.222-.383.66-.158.956l1.8 2.37-1.8 2.335c-.225.296-.142.735.158.956.3.222.742.185.967-.111l1.542-2.035 1.53 2.035c.225.296.68.37.979.11.336-.22.367-.622.18-.955l-1.79-2.37 1.79-2.368c.225-.296.153-.745-.146-.967-.15-.112-.34-.152-.518-.134zm-13.716 1.39c1.162 0 2.093.932 2.093 2.08 0 1.148-.931 2.068-2.093 2.068-1.16 0-2.093-.92-2.093-2.068 0-1.148.933-2.08 2.093-2.08zm6.177 0c1.162 0 2.104.932 2.104 2.08 0 1.148-.942 2.068-2.104 2.068-1.16 0-2.092-.92-2.092-2.068 0-1.148.932-2.08 2.092-2.08z"
            transform="translate(-158 -295) translate(126 23) translate(32 220) translate(0 52)"
          />
        </g>
      </g>
    </svg>
  );
};

export default BoxOutline;
